/* Scrolling the page back to the top, smoothly. */

/* Someone who has asked their OS for less motion gets the instant jump — a
 * smooth scroll is exactly the vestibular trigger that setting exists for.
 * matchMedia is missing in some test environments, hence the guard. */
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const scrollToTop = () => {
  if (typeof window === "undefined" || typeof window.scrollTo !== "function") return;

  if (prefersReducedMotion()) {
    window.scrollTo(0, 0);
    return;
  }

  /* Older Safari throws on the options form rather than ignoring it, so the
     two-argument call stays as the fallback. */
  try {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  } catch {
    window.scrollTo(0, 0);
  }
};

export default scrollToTop;
